var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { applyOpenGraphThumbnailSize, classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { EntityValue } from '../entities/entity-value';
import { animated } from '@react-spring/web';
var cls = classNames('entity-option-menu-item');
export var OptionMenuItemEntityValueDefaultProps = {
  valueProps: {
    variant: 'card',
    showImageBorder: true
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: inherit;\n    user-select: none;\n    color: ", ";\n    min-height: 38px; /* avoids pixel jumps */\n    .shp--cell-label,\n    .shp--cell-header {\n      color: ", ";\n    }\n  "], ["\n    color: inherit;\n    user-select: none;\n    color: ", ";\n    min-height: 38px; /* avoids pixel jumps */\n    .shp--cell-label,\n    .shp--cell-header {\n      color: ", ";\n    }\n  "])), theme.COLOR('strong'), theme.COLOR('sub'))
});
// -------- Components -------->
var My = {
  NAME: 'OptionMenuItemEntityValue',
  Container: styled(animated(EntityValue))(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var OptionMenuItemEntityValue = function (props) {
  var _a;
  var componentProps = useComponentProps(My.NAME, OptionMenuItemEntityValueDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    item = componentProps.item,
    style = componentProps.style,
    highlightText = componentProps.highlightText,
    isSelected = componentProps.isSelected,
    _b = componentProps.valueProps,
    valueProps = _b === void 0 ? {} : _b;
  var entity = applyOpenGraphThumbnailSize('bubbleMedium')((_a = item === null || item === void 0 ? void 0 : item.data) === null || _a === void 0 ? void 0 : _a.entity);
  if (!entity) return null;
  return React.createElement(My.Container, __assign({}, valueProps, {
    style: style,
    badge: isSelected ? 'selected' : undefined,
    highlight: highlightText,
    entity: entity,
    className: cls.name(className)
  }));
};
OptionMenuItemEntityValue.cls = cls;
var templateObject_1, templateObject_2;